import { makeVar } from '@apollo/client';

export const SetActiveCartButtonState = makeVar<boolean>(false);
